import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, CardMedia } from "@mui/material";
import { useLazyGetSubAdminByIdQuery } from "../../services/subAdmin";
import { showError } from "../../constants/toasts";
import moment from "moment";

const ViewSubadmin = () => {
  const [getSubAdminById] = useLazyGetSubAdminByIdQuery();
  const [subAdmin, setSubAdmin] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  const fetchSubAdminById = async () => {
    if (!id) return;
    try {
      setLoading(true);
      const numericId = Number(id);
      if (Number.isNaN(numericId)) return;
      const response = await getSubAdminById({ id: numericId }).unwrap();
      if (response?.status === 200 || response?.statusCode === 200) {
        setSubAdmin(response.data);
      }
    } catch (error: any) {
      showError(error?.message || error?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubAdminById();
  }, [id]);

  if (loading) {
    return (
      <div className="main_title">
        <h1>Loading...</h1>
      </div>
    );
  }

  if (!subAdmin) {
    return (
      <div className="main_title">
        <h1>Subadmin not found</h1>
      </div>
    );
  }

  return (
    <>
      <div className="main_title">
        <h1>View Subadmin</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> -{" "}
          <span onClick={() => navigate("/manage-subadmin")}>
            Subadmin Management
          </span>{" "}
          - View
        </p>
      </div>

      <div className="cards">
        <div className="form">
          <div className="gap_p">
            <div className="control_group">
              <label>Profile Image</label>
              {subAdmin?.profile_picture?.media_file_url ? (
                <div className="upload_image">
                  <div className="upload_image_holder">
                    <figure>
                      <CardMedia
                        component="img"
                        image={subAdmin?.profile_picture.media_file_url}
                        alt="profile"
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "cover",
                        }}
                      />
                    </figure>
                  </div>
                </div>
              ) : (
                <div className="upload_image">
                  <div className="upload_image_holder">
                    <figure>
                      <img
                        src="/static/images/user_placeholder.png"
                        alt="placeholder"
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "cover",
                        }}
                      />
                    </figure>
                  </div>
                </div>
              )}
            </div>
            <div className="control_group w_33">
              <label>First Name</label>
              <div className="view_field">{subAdmin?.first_name || "N/A"}</div>
            </div>
            <div className="control_group w_33">
              <label>Last Name</label>
              <div className="view_field">{subAdmin?.last_name || "N/A"}</div>
            </div>
            <div className="control_group w_33">
              <label>Email</label>
              <div className="view_field">{subAdmin?.email || "N/A"}</div>
            </div>
            <div className="control_group w_33">
              <label>Phone Number</label>
              <div className="view_field">
                {subAdmin?.country_code && subAdmin?.phone_number
                  ? `${subAdmin?.country_code} ${subAdmin?.phone_number}`
                  : "N/A"}
              </div>
            </div>
            <div className="control_group w_33">
              <label>Role</label>
              <div className="view_field">
                {subAdmin.role?.role_name || "N/A"}
              </div>
            </div>
            <div className="control_group w_33">
              <label>Status</label>
              <div className="view_field">
                <span
                  className={`status_badge ${
                    subAdmin?.is_active === true ? "active" : "inactive"
                  }`}
                >
                  {subAdmin?.is_active === true ? "Active" : "Inactive"}
                </span>
              </div>
            </div>
            <div className="control_group w_33">
              <label>Created Date</label>
              <div className="view_field">
                <p>
                  {subAdmin?.created_at
                    ? moment(subAdmin?.created_at).format("DD MMMM YYYY")
                    : "N/A"}
                </p>
              </div>
            </div>
          </div>
          <div className="form_btn">
            <Button
              className="btn btn_secondary"
              onClick={() => navigate(`/manage-subadmin/add/${subAdmin?.id}`)}
            >
              Edit Subadmin
            </Button>
            <Button
              className="btn btn_primary"
              onClick={() => navigate("/manage-subadmin")}
            >
              Back to List
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewSubadmin;
